import {
	CDN_URL,
	RECURSIVE_CONTENT_URL,
	RECURSIVE_RENDERER_IMAGE_SIZE,
	RECURSIVE_RENDERER_URL,
	RECURSIVE_RENDERER_VERSION,
	RENDER_URL,
} from './constants'

type GetInscriptionContentRenderTargetArgs = {
	id: string
	contentType?: string | null
	preferStaticRenderer: boolean
	// Square screenshot edge in px; the renderer's viewport is this size too.
	rendererSize?: number
}

export function getInscriptionContentRenderTarget({
	id,
	contentType,
	preferStaticRenderer,
	rendererSize = RECURSIVE_RENDERER_IMAGE_SIZE,
}: GetInscriptionContentRenderTargetArgs) {
	const isSvg = contentType?.includes('image/svg')
	const isHtml = contentType?.includes('text/html')
	const isModel = contentType?.includes('model')
	const isNoContentType = contentType === 'no_content_type'
	let url
	let showScreenshot = false

	if (preferStaticRenderer && (isHtml || isSvg || isModel || isNoContentType)) {
		const mode = isModel ? '&mode=model' : ''
		url = `${RECURSIVE_RENDERER_URL}/${encodeURIComponent(id)}?size=${rendererSize}&v=${encodeURIComponent(RECURSIVE_RENDERER_VERSION)}${mode}`
		showScreenshot = true
	} else if (isSvg) {
		url = `${RENDER_URL}/${id}`
	} else if (isHtml) {
		url = `${RECURSIVE_CONTENT_URL}/${id}`
	} else {
		url = `${CDN_URL}/${id}`
	}

	return {
		url,
		showScreenshot,
		is_image: Boolean(contentType?.includes('image')),
	}
}
